module.exports = __webpack_public_path__ + "media/images/vouchers/absolution_mains-101d2d89f0342f015a342b0a38ac1c47.png";